module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    staticClass: "numberCard",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "bordered": "false"
    }
  }, [_c('div', {
    staticClass: "iconWrap"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cardname))]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.cardvalue))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5eb89b22"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/NumberCard.vue
// module id = 254
// module chunks = 2